import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { CONTENT_MANAGEMENT_VALIDATION } from '@configs'
import { ICategory } from '@interfaces'
import { LexicalComposer } from '@lexical/react/LexicalComposer'
import {
  getAllCategoriesAction,
  getListTicket,
  selectBlogLoading,
  useAppDispatch,
  useAppSelector,
} from '@redux'
import { Card, message } from 'antd'
import { t } from 'i18next'
import moment from 'moment'
import {
  Dispatch,
  Fragment,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import {
  Controller,
  UseFieldArrayReturn,
  useFormContext,
} from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { workshopEventApi } from 'src/api/workshopEvent'
import { Button, Input, Loading, SwitchButton } from 'src/common'
import { CustomDragger } from 'src/common/upload/CustomDragger'
import { useSettings } from 'src/components/editor/context/SettingsContext'
import Editor from 'src/components/editor/Editor'
import PlaygroundNodes from 'src/components/editor/nodes/PlaygroundNodes'
import PlaygroundEditorTheme from 'src/components/editor/themes/PlaygroundEditorTheme'
import SelectMedia from 'src/components/gallery/SelectMedia'
import SelectMediaModal from 'src/components/gallery/SelectMediaModal'
import { ShareSelectInput } from 'src/components/shared'
import { useDebounce } from 'src/hooks/useDebounce'
import { ITicket, ITicketResponse } from 'src/interfaces/event-posts'
import { EMediaCategory, EMediaType, IMediaItem } from 'src/interfaces/gallery'
import { IEventDataDetail, IPackageShop } from 'src/interfaces/workshopEvent'
import { IWorkshopEventSchema } from 'src/pages/event-management/WorkshopAndEventFormPage/schema'
import { InputWrapperGridStyled } from 'src/theme/styled'
import styled from 'styled-components'

type IProps = {
  onCancel?: () => void
  title?: string
  jobId?: string
  activeTab?: string
  imageSrc: string
  setImageSrc: Dispatch<SetStateAction<string>>
  imageMobileSrc: string
  setImageMobileSrc: Dispatch<SetStateAction<string>>
  workshopEventDetail?: IEventDataDetail
  isGettingDetail?: boolean
  listPackageShops: UseFieldArrayReturn<
    {
      eventGuid: string
      categoryId: number
      isPublished: boolean
      description: string
      packageAndShop: {
        packageId: number | null
        shopGuid: string
        isDefault: boolean
        ticketLimits: {
          ticketName: string | null
          ticketGuid: string | null
          maxPerUser: number
        }[]
      }[]
      backgroundId: number
      mobileBackgroundId: number
      mediaId?: number
      mediaMobileId?: number
      metaTitle: string
      metaDescription: string
      canonical: string
      schemaMarkup: string
      metaImage: string
      keywords: string
      subcategoryIds?: number[] | undefined
      location?: string | undefined
      startTime?: string | undefined
      endTime?: string | undefined
    },
    'packageAndShop',
    'id'
  >
}
interface IEventOption {
  value: string
  label: string
  location: string
  startTime: string
  endTime: string
}
interface IPageInfo {
  currentPage: number
  total?: number
}

export const AddNewForm = ({
  title,
  imageMobileSrc,
  imageSrc,
  setImageMobileSrc,
  setImageSrc,
  workshopEventDetail,
  isGettingDetail,
  listPackageShops,
}: IProps) => {
  const dispatch = useAppDispatch()
  const { eventId } = useParams()

  const {
    control,
    setValue,
    watch,
    getValues,
    clearErrors,
    setError,
    trigger,
    formState: { errors },
  } = useFormContext<IWorkshopEventSchema>()

  //plan
  const [listPackage, setListPackage] = useState<any>([])
  const [isGettingPlan, setIsGettingPlan] = useState(false)
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
  })
  const [planSearch, setPlanSearch] = useState('')
  const searchDebounce = useDebounce<string | null>(planSearch, 800)

  //event-shop
  const eventGuid = watch('eventGuid')

  const [eventShops, setEventShops] = useState<any>([])
  const [isGettingEventShopId, setIsGettingEventShopId] = useState(false)

  //categories
  const [selectedTags, setSelectedTags] = useState<ICategory[]>([])
  
  const [selectMediaType, setSelectMediaType] = useState<EMediaType>(
    EMediaType.VIDEO
  )

  const [isLoadingListTicket, setIsLoadingListTicket] = useState<boolean[]>([])
  const [isModalMobileLoading, setIsModalMobileLoading] = useState(false)
  const [isModalVideoLoading, setIsModalVideoLoading] = useState(false)
  const [videoSrc, setVideoSrc] = useState('')

  const [videoMobileSrc, setVideoMobileSrc] = useState('')

  const categories = useAppSelector((state) => state.categories)?.categories

  const getBlogDetailActionLoading = useAppSelector((state) =>
    selectBlogLoading(state, 'getBlogDetailActionLoading')
  )
  const handleChangeCategories = (value: any) => {
    setValue('categoryId', value)
    setValue('subcategoryIds', [] as any)
    trigger('categoryId')
    const selectedSubCategories = categories.filter(
      (category) => category.id === value
    )
    setSelectedTags(selectedSubCategories)
  }

  const onChangeDesktopImageRef = useRef<any>(null)
  const onChangeMobileImageRef = useRef<any>(null)
  const onChangeDesktopVideoRef = useRef<any>(null)
  const onChangeMobileVideoRef = useRef<any>(null)

  const [showModalSelectMedia, setShowModalSelectMedia] = useState(false)
  const [selectedField, setSelectedField] = useState<
    'desktop' | 'mobile' | null
  >(null)

  const [isModalLoading, setIsModalLoading] = useState(false)
  //event from WT
  const [listEventFromWT, setListEventFromWT] = useState<IEventOption[]>([])
  const [isGettingListEventFromWT, setIsGettingListEventFromWT] =
    useState(false)

  const {
    settings: { isCollab, emptyEditor },
  } = useSettings()

  const initialConfig: any = {
    editorState: isCollab ? null : emptyEditor,
    namespace: 'Playground',
    nodes: [...PlaygroundNodes],
    onError: (error: Error) => {
      throw error
    },
    theme: PlaygroundEditorTheme,
  }

  const onCloseModalSelectMedia = () => {
    setShowModalSelectMedia(false)
  }
  const onSelectMedia = (data: IMediaItem) => {
    if (selectedField === 'desktop') {
      setImageSrc(data?.baseUrl ?? '')
      setValue('backgroundId', data?.id ?? 0)
      onChangeDesktopImageRef.current(data?.id ?? 0)
    } else if (selectedField === 'mobile') {
      setImageMobileSrc(data?.baseUrl ?? '')
      setValue('mobileBackgroundId', data?.id ?? 0)
      onChangeDesktopImageRef.current(data?.id ?? 0)
    }
    setShowModalSelectMedia(false)
  }
  // Select Video
  const onSelectMediaVideoAndImage = (data: IMediaItem) => {
    if (selectMediaType === EMediaType.VIDEO) {
      onSelectVideo(data)
      return
    }

    onSelectMedia(data)
    setShowModalSelectMedia(false)
  }

  const onSelectVideo = (data: IMediaItem) => {
    if (selectedField === 'desktop') {
      setValue('mediaId', data?.id ?? 0)
      onChangeDesktopVideoRef.current(data?.id ?? 0)
      setVideoSrc(data?.baseUrl ?? '')
    } else if (selectedField === 'mobile') {
      setValue('mediaMobileId', data?.id ?? 0)
      onChangeMobileVideoRef.current(data?.id ?? 0)
      setVideoMobileSrc(data?.baseUrl ?? '')
    }
  }

  const packageAndShopValues = watch('packageAndShop')

  const handleAppendItem = () => {
    listPackageShops.append({
      packageId: undefined as any,
      shopGuid: undefined as any,
      isDefault: false,
      ticketLimits: [],
    })
  }

  const handleDeleteIem = (index?: number) => {
    if (listPackageShops.fields.length > 1) {
      listPackageShops.remove(index)
    }
  }

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement
    if (
      target.scrollTop + target.offsetHeight === target.scrollHeight &&
      !isGettingPlan &&
      pageInfo.total &&
      listPackage.length < pageInfo?.total
    ) {
      getListPackage(pageInfo.currentPage + 1, planSearch, false)
    }
  }

  const getListEventFromWT = async () => {
    try {
      let res
      setIsGettingListEventFromWT(true)
      if (eventId) {
        res = await workshopEventApi.getListEventsFromWT()
      } else {
        // Exclude events that already exist in database when creating new event
        res = await workshopEventApi.getListEventsUpcomingFromWT({
          excludeExisting: true,
        })
      }
      if (res.success) {
        const data = res.data?.map((item) => ({
          value: item.guid,
          label: item.name,
          location: `${item.location.name}, ${item.location.address}`,
          startTime: moment(item.start).format('DD/MM/YY, HH:mm'),
          endTime: moment(item.end).format('DD/MM/YY, HH:mm'),
        }))
        setListEventFromWT(data)
      }
    } catch (error: any) {
      message.error({
        content: error?.message ?? t('error:Can not get list events select'),
      })
    } finally {
      setIsGettingListEventFromWT(false)
    }
  }

  const getListPackage = async (
    page: number,
    search?: string,
    isSearch?: boolean
  ) => {
    try {
      setIsGettingPlan(true)
      const res = await workshopEventApi.getListPackage({
        page: page,
        limit: 10,
        search: search,
        isActive: true,
      })
      if (res.success) {
        const data = res.data?.items?.map((item) => ({
          value: item.id,
          label: item.name,
        }))
        if (Array.isArray(data)) {
          if (isSearch) {
            setListPackage(data)
          } else {
            setListPackage((pre: any) => pre.concat(data))
          }
        }
        setPageInfo({ total: res.data.total, currentPage: res.data.page })
      }
    } catch (error: any) {
      message.error({
        content: error?.message ?? t('error:Can not get list Package select'),
      })
    } finally {
      setIsGettingPlan(false)
    }
  }

  const getListEventShop = async (eventId: string) => {
    try {
      setIsGettingEventShopId(true)
      const res = await workshopEventApi.getListShopFromWT(eventId)
      if (res.success) {
        const data = res.data?.map((item) => ({
          value: item.guid,
          label: item.name,
        }))
        setEventShops(data)
      }
    } catch (error: any) {
      message.error({
        content: error?.message ?? t('error:Can not get list shop select'),
      })
    } finally {
      setIsGettingEventShopId(false)
    }
  }

  const handleSelectItem = async (guid: string, index: number) => {
    if (!guid) return
    if (index === 0) return
    let ticketFind: IPackageShop | undefined
    ticketFind = workshopEventDetail?.eventShops
      .slice(1)
      .find((item) => item?.guid === guid)

    try {
      setIsLoadingListTicket((prev) => {
        const next = [...prev]
        next[index] = true
        return next
      })
      const result = await dispatch(getListTicket({ guid })).unwrap()

      const resultData = result as ITicketResponse
      const data = resultData?.data

      let tickets: ITicket[] = []
      if (data) {
        if (Array.isArray((data as any).items)) {
          tickets = (data as any).items
        } else if (Array.isArray(data)) {
          tickets = data
        }
      }

      const ticketLimits = tickets.map((ticket: ITicket, index) => ({
        ticketName: ticket.name,
        ticketGuid: ticket.guid || null,
        maxPerUser: ticketFind?.ticketLimits[index].maxPerUser ?? 1,
      }))

      setValue(`packageAndShop.${index}.ticketLimits`, ticketLimits)
    } catch (error) {
      message.error({
        content: 'Cannot get list tickets',
      })
    } finally {
      setIsLoadingListTicket((prev) => {
        const next = [...prev]
        next[index] = false
        return next
      })
    }
  }

  useEffect(() => {
    getListEventFromWT()
    dispatch(getAllCategoriesAction())
  }, [])

  useEffect(() => {
    getListPackage(1, searchDebounce ?? '', true)
  }, [searchDebounce])

  useEffect(() => {
    if (eventGuid) {
      getListEventShop(eventGuid)
    }
  }, [eventGuid])
  useEffect(() => {
    if (workshopEventDetail && eventShops) {
      setValue('eventGuid', workshopEventDetail.guid)
      setValue(
        'location',
        `${workshopEventDetail.location?.name || ''}${
          workshopEventDetail.location?.address && ','
        } ${workshopEventDetail.location?.address || ''}`
      )
      setValue(
        'startTime',
        workshopEventDetail.start
          ? moment(workshopEventDetail.start).format('DD/MM/YY, HH:mm')
          : ''
      )
      setValue(
        'endTime',
        workshopEventDetail.end
          ? moment(workshopEventDetail.end).format('DD/MM/YY, HH:mm')
          : ''
      )
      setValue(
        'categoryId',
        workshopEventDetail.categoryId || (undefined as any)
      )
      setValue('subcategoryIds', workshopEventDetail.subcategoryIds as any)
      setValue('description', `${workshopEventDetail.description || ''}`)
      setValue(
        'backgroundId',
        workshopEventDetail.background?.id || (undefined as any)
      )
      setValue(
        'mobileBackgroundId',
        workshopEventDetail.mobileBackground?.id || (undefined as any)
      )
      setValue('isPublished', workshopEventDetail.isPublished)
      setImageSrc(workshopEventDetail.background?.url || '')
      setImageMobileSrc(workshopEventDetail.mobileBackground?.url || '')

      setValue(
        'mediaMobileId',
        workshopEventDetail.mediaMobileBackground?.id || (undefined as any)
      )
      setValue(
        'mediaId',
        workshopEventDetail.mediaBackground?.id || (undefined as any)
      )

      setVideoMobileSrc(
        workshopEventDetail.mediaMobileBackground?.baseUrl || ''
      )
      setVideoSrc(workshopEventDetail.mediaBackground?.baseUrl || '')

      const eventShop =
        workshopEventDetail.eventShops?.map((item, index) => ({
          packageId: item.packageId,
          shopGuid: item.guid || '',
          isDefault: item.isDefault,
          ticketLimits: [],
        })) || []
      listPackageShops.replace([...eventShop])

      eventShop.forEach((item, index) => {
        if (item.shopGuid) {
          setTimeout(() => {
            handleSelectItem(item.shopGuid, index)
          }, 100)
        }
      })
    }
  }, [workshopEventDetail])

  useEffect(() => {
    if (categories && categories?.length && workshopEventDetail) {
      const selectedSubCategories = categories.filter(
        (category) => category.id === workshopEventDetail.categoryId
      )
      setSelectedTags(selectedSubCategories)
    }
  }, [categories, workshopEventDetail])

  const handleDeleteMedia = (type: string) => {
    switch (type) {
      case 'backgroundId':
        setValue('backgroundId', 0)
        setImageSrc('')
        onChangeDesktopImageRef.current?.(0)
        break

      case 'mobileBackgroundId':
        setValue('mobileBackgroundId', 0)
        setImageMobileSrc('')
        onChangeMobileImageRef.current?.(0)
        break

      case 'mediaId':
        setValue('mediaId', undefined)
        setVideoSrc('')
        onChangeDesktopVideoRef.current?.(undefined)
        break

      case 'mediaMobileId':
        setValue('mediaMobileId', undefined)
        setVideoMobileSrc('')
        onChangeMobileVideoRef.current?.(undefined)
        break
    }
  }

  return (
    <Card>
      {isGettingDetail ? (
        'loading'
      ) : (
        <div data-aos="fade-right">
          <div className="flex justify-between">
            <h1 className="text-xl mb-5">
              {title || t('evolveLanding:add_new_event')}
            </h1>
            <div className="flex items-center">
              <label htmlFor="" className="text-dark font-medium mr-2">
                Publish:
              </label>
              <Controller
                control={control}
                name="isPublished"
                render={({ field }) => (
                  <SwitchButton
                    checked={field.value}
                    onChange={field.onChange}
                  />
                )}
              />
            </div>
          </div>

          <div className="grid  gap-x-8 gap-y-8">
            <Controller
              control={control}
              name="eventGuid"
              render={({ field, fieldState: { error } }) => (
                <ShareSelectInput
                  placeholder={t('evolveLanding:search_workshopEvent')}
                  errors={error?.message}
                  label={t('evolveLanding:title')}
                  inlineLabelClassName="text-dark !font-medium"
                  required
                  loading={isGettingListEventFromWT}
                  disabled={workshopEventDetail?.id ? true : false}
                  options={listEventFromWT as any}
                  showSearch
                  value={!isGettingListEventFromWT ? field.value : undefined}
                  onSelect={(data, option) => {
                    field.onChange(data)
                    setValue('startTime', option.startTime)
                    setValue('endTime', option.endTime)
                    setValue('location', option.location)
                    trigger(['location', 'startTime', 'endTime'])
                    const packageAndShop = getValues('packageAndShop')

                    setValue(
                      `packageAndShop`,
                      packageAndShop.map((item) => ({
                        ...item,
                        shopGuid: undefined as any,
                      }))
                    )
                  }}
                />
              )}
            />

            {eventGuid && (
              <>
                <Controller
                  control={control}
                  name="location"
                  render={({ field, fieldState: { error } }) => (
                    <Input
                      className="!h-[38px]"
                      alignment="col"
                      required
                      disabled
                      label={t('evolveLanding:location')}
                      labelClassName="text-dark font-medium"
                      placeholder={t('evolveLanding:location')}
                      errors={error?.message}
                      {...field}
                    />
                  )}
                />
                <div className="grid grid-cols-2 gap-4">
                  <Controller
                    control={control}
                    name="startTime"
                    render={({ field, fieldState: { error } }) => (
                      <Input
                        className="!h-[38px]"
                        alignment="col"
                        required
                        disabled
                        label={t('evolveLanding:startAt')}
                        labelClassName="text-dark font-medium"
                        placeholder={t('evolveLanding:startAt')}
                        errors={error?.message}
                        {...field}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="endTime"
                    render={({ field, fieldState: { error } }) => (
                      <Input
                        className="!h-[38px]"
                        alignment="col"
                        required
                        disabled
                        label={t('evolveLanding:endAt')}
                        labelClassName="text-dark font-medium"
                        placeholder={t('evolveLanding:endAt')}
                        errors={error?.message}
                        {...field}
                      />
                    )}
                  />
                </div>
              </>
            )}

            <div className="space-y-5">
              <Controller
                name="categoryId"
                control={control}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => {
                  return (
                    <ShareSelectInput
                      data={
                        !getBlogDetailActionLoading
                          ? categories &&
                            categories?.map((item, index) => {
                              return {
                                label: item.name,
                                value: item.id,
                              }
                            })
                          : []
                      }
                      label="Categories"
                      placeholder="Select categories"
                      inlineLabelClassName="text-dark !font-medium"
                      value={value}
                      onChange={handleChangeCategories}
                      errors={error?.message}
                      required
                      showArrow
                    />
                  )
                }}
              />
              {getBlogDetailActionLoading || !selectedTags?.length ? (
                <></>
              ) : (
                <Controller
                  name="subcategoryIds"
                  control={control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => {
                    return (
                      <ShareSelectInput
                        options={
                          getBlogDetailActionLoading || !selectedTags?.length
                            ? []
                            : (selectedTags?.map((item) => {
                                return {
                                  label: item.name,
                                  options: item.subCategories?.map((it) => ({
                                    label: it.name,
                                    value: it.id,
                                  })),
                                }
                              }) as any)
                        }
                        label="Sub-categories"
                        inlineLabelClassName="text-dark !font-medium"
                        mode="multiple"
                        placeholder={`${selectedTags[0].subCategories.length === 0 ? 'There are no sub-categories in this category.' : 'Select sub-category'} `}
                        onChange={(e) => {
                          onChange(e)
                        }}
                        disabled={selectedTags[0].subCategories.length === 0}
                        value={value}
                        errors={error?.message}
                        onFocus={() => {
                          if (selectedTags.length === 0) {
                            message.warning('Please select categories first!')
                          }
                        }}
                        showArrow
                      />
                    )
                  }}
                />
              )}
            </div>

            <div className="flex flex-col gap-y-6">
              {listPackageShops.fields.map((item, index) => {
                return (
                  <div
                    key={item.id}
                    className="border-slate-200 border rounded-md grid grid-cols-2 px-4 py-8 gap-4 relative shadow-md"
                  >
                    {!item.isDefault && listPackageShops.fields.length > 1 && (
                      <MinusOutlined
                        onClick={() => handleDeleteIem(index)}
                        className="text-2xl absolute right-3 top-3 cursor-pointer"
                      />
                    )}
                    {!item.isDefault && (
                      <Controller
                        control={control}
                        name={`packageAndShop.${index}.packageId`}
                        render={({ field, fieldState: { error } }) => (
                          <ShareSelectInput
                            required
                            options={listPackage}
                            label={t('evolveLanding:selectPlan')}
                            inlineLabelClassName="text-dark !font-medium"
                            className="!h-[38px]"
                            style={{ marginTop: 0 }}
                            placeholder={t('evolveLanding:selectPlan')}
                            errors={error?.message}
                            value={
                              !isGettingPlan ? (field.value as any) : undefined
                            }
                            loading={isGettingPlan}
                            showArrow
                            showSearch
                            onChange={field.onChange}
                            onPopupScroll={handleScroll}
                            onSearch={(val) => setPlanSearch(val)}
                          />
                        )}
                      />
                    )}
                    <Controller
                      control={control}
                      name={`packageAndShop.${index}.shopGuid`}
                      render={({ field, fieldState: { error } }) => (
                        <ShareSelectInput
                          required
                          options={eventShops}
                          label={
                            !item.isDefault
                              ? t('evolveLanding:selectShop')
                              : t('evolveLanding:select_default_shop')
                          }
                          inlineLabelClassName="text-dark !font-medium"
                          className="!h-[38px]"
                          style={{ marginTop: 0 }}
                          placeholder={t('evolveLanding:selectShop')}
                          errors={error?.message}
                          loading={isGettingEventShopId}
                          value={
                            !isGettingEventShopId ? field.value : undefined
                          }
                          onChange={(value) => {
                            field.onChange(value)
                            if (value) {
                              handleSelectItem(value, index)
                            } else {
                              setValue(
                                `packageAndShop.${index}.ticketLimits`,
                                []
                              )
                            }
                          }}
                        />
                      )}
                    />

                    {packageAndShopValues?.[index]?.shopGuid &&
                      !item.isDefault && (
                        <div className="col-span-2 flex flex-col gap-4">
                          {isLoadingListTicket[index] ? (
                            <Loading />
                          ) : (
                            (
                              packageAndShopValues?.[index]?.ticketLimits ?? []
                            ).map((ticket, ticketIndex) => (
                              <div
                                key={
                                  ticket.ticketGuid || `${index}-${ticketIndex}`
                                }
                                className="grid grid-cols-2 gap-4 items-start"
                              >
                                <Input
                                  className="!h-[38px]"
                                  alignment="col"
                                  disabled
                                  label={'Name of ticket'}
                                  labelClassName="text-dark font-medium"
                                  placeholder={t('evolveLanding:location')}
                                  value={ticket?.ticketName || ''}
                                />
                                <Controller
                                  control={control}
                                  name={`packageAndShop.${index}.ticketLimits.${ticketIndex}.maxPerUser`}
                                  render={({
                                    field,
                                    fieldState: { error },
                                  }) => {
                                    const { value, onChange, ...restField } =
                                      field
                                    return (
                                      <Input
                                        className="!h-[38px]"
                                        alignment="col"
                                        required
                                        label="Max"
                                        labelClassName="text-dark font-medium"
                                        placeholder="Enter max of ticket"
                                        // type="number"
                                        errors={error?.message}
                                        value={value ?? ''}
                                        onChange={(e) =>
                                          onChange(Number(e.target.value) ?? '')
                                        }
                                        {...restField}
                                      />
                                    )
                                  }}
                                />
                              </div>
                            ))
                          )}
                        </div>
                      )}
                  </div>
                )
              })}

              <Button
                onClick={() => handleAppendItem()}
                type="primary"
                className="self-end "
              >
                <PlusOutlined className="text-2xl" />
                Add more
              </Button>
            </div>

            <div>
              <label className="text-dark mb-2 inline-block font-medium">
                {t('evolveLanding:description')}
                <span className="required text-[#B91C1C] font-bold">*</span>
              </label>
              <div
                className={`w-full border rounded-md ${
                  errors.description ? 'border-danger' : 'border-slate-200'
                }`}
              >
                <LexicalComposer initialConfig={initialConfig}>
                  <div className="editor-shell">
                    <Controller
                      name={'description'}
                      control={control}
                      render={({
                        field: { value, onChange },
                        fieldState: { error },
                      }) => {
                        return (
                          <Fragment>
                            <Editor
                              setValue={setValue}
                              clearErrors={clearErrors}
                              setError={setError}
                              value={value}
                              contentName={'description'}
                              config={{ minLength: 1, isRequired: true }}
                            />
                          </Fragment>
                        )
                      }}
                    />
                  </div>
                </LexicalComposer>
              </div>
              {errors.description && errors.description.message && (
                <p className="text-[#B91C1C] mt-2  text-sm">
                  {errors.description.message}
                </p>
              )}
            </div>

            <InputWrapperGridStyled>
              <div className="flex flex-col w-full gap-1 items-end">
                <Controller
                  name="backgroundId"
                  control={control}
                  render={({ field: { onChange }, fieldState: { error } }) => {
                    onChangeDesktopImageRef.current = onChange
                    return (
                      <CustomDragger
                        label="Image"
                        name="mediaTopId"
                        id="mediaTopId"
                        containerClassName="mt-3"
                        alignment="col"
                        required
                        onLoadEnd={(data) => {
                          setValue('backgroundId', data?.id ?? 0)
                          onChange(data?.id ?? 0)
                          setImageSrc((prev) => data.original ?? prev)
                        }}
                        errors={error?.message}
                        initResource={imageSrc}
                        reset={getValues('backgroundId') === 0}
                        limitFileSize={5}
                        allowFileTypes={[
                          'image/png',
                          'image/jpeg',
                          'image/jpg',
                        ]}
                        className=""
                        changeLoading={setIsModalLoading}
                        uploadType={EMediaType.IMAGE as any}
                        uploadCategory={EMediaCategory.CONTENT}
                      />
                    )
                  }}
                />
                <SelectMedia
                  buttonClassName="w-fit ml-auto"
                  isNotGrid
                  onClickSelectMedia={() => {
                    setSelectedField((pre) => 'desktop')
                    setShowModalSelectMedia(true)
                    setSelectMediaType(EMediaType.IMAGE)
                  }}
                  isLoadingMedia={isModalLoading}
                />
              </div>

              <div className="flex flex-col gap-1 items-end mb-4">
                <Controller
                  name={'mobileBackgroundId'}
                  control={control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => {
                    onChangeMobileImageRef.current = onChange
                    return (
                      <>
                        <CustomDragger
                          label="Image mobile"
                          containerClassName="mt-[10px]"
                          alignment="col"
                          onLoadEnd={(data) => {
                            setValue('mobileBackgroundId', data?.id ?? 0)
                            onChange(data?.id ?? 0)
                          }}
                          name="mediaMobileTopId"
                          id="mediaMobileTopId"
                          required
                          errors={error?.message}
                          multiple={false}
                          initResource={imageMobileSrc}
                          reset={getValues('mobileBackgroundId') === 0}
                          allowFileTypes={[
                            'image/png',
                            'image/jpeg',
                            'image/jpg',
                          ]}
                          limitFileSize={5}
                          changeLoading={setIsModalLoading}
                          uploadType={EMediaType.IMAGE as any}
                          uploadCategory={EMediaCategory.CONTENT}
                        />
                      </>
                    )
                  }}
                />
                <SelectMedia
                  buttonClassName="w-fit ml-auto"
                  isNotGrid
                  onClickSelectMedia={() => {
                    setSelectedField((pre) => 'mobile')
                    setShowModalSelectMedia(true)
                    setSelectMediaType(EMediaType.IMAGE)
                  }}
                  isLoadingMedia={isModalLoading}
                />
              </div>
            </InputWrapperGridStyled>

            <InputWrapperVideoGridStyled className="grid grid-cols-2 gap-2">
              <div className="flex flex-col gap-1 items-end w-full">
                <Controller
                  name="mediaId"
                  control={control}
                  render={({ field: { onChange }, fieldState: { error } }) => {
                    onChangeDesktopVideoRef.current = onChange
                    return (
                      <CustomDragger
                        label="Video"
                        name="mediaId"
                        id="mediaId"
                        containerClassName="mt-3"
                        alignment="col"
                        handleDeleteMedia={handleDeleteMedia}
                        onLoadEnd={(data) => {
                          setValue('mediaId', data?.dataValues.id ?? 0)
                          onChange(data?.dataValues.id ?? 0)
                          setVideoSrc((prev) => data.original ?? prev)
                        }}
                        errors={error?.message}
                        initResource={videoSrc}
                        reset={getValues('mediaId') === 0}
                        allowFileTypes={[
                          'video/mp4',
                          'video/webm',
                          'video/m4v',
                          'video/mov',
                          'video/qt',
                        ]}
                        limitFileSize={
                          CONTENT_MANAGEMENT_VALIDATION.MAX_VIDEO_SIZE
                        }
                        minFileSize={
                          CONTENT_MANAGEMENT_VALIDATION.MIN_VIDEO_SIZE
                        }
                        changeLoading={setIsModalVideoLoading}
                        uploadType={EMediaType.VIDEO as any}
                        uploadCategory={EMediaCategory.CONTENT}
                      />
                    )
                  }}
                />
                <SelectMedia
                  buttonClassName="w-fit ml-auto"
                  isNotGrid
                  onClickSelectMedia={() => {
                    setSelectedField((pre) => 'desktop')
                    setShowModalSelectMedia(true)
                    setSelectMediaType(EMediaType.VIDEO)
                  }}
                  isLoadingMedia={isModalVideoLoading}
                />
              </div>

              <div className="flex flex-col gap-1 items-end mb-4 w-full">
                <Controller
                  name={'mediaMobileId'}
                  control={control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => {
                    onChangeMobileVideoRef.current = onChange
                    return (
                      <>
                        <CustomDragger
                          label="Video Mobile"
                          containerClassName="mt-[10px]"
                          handleDeleteMedia={handleDeleteMedia}
                          alignment="col"
                          onLoadEnd={(data) => {
                            setValue('mediaMobileId', data?.dataValues.id ?? 0)
                            onChange(data?.dataValues.id ?? 0)
                            setVideoMobileSrc((prev) => data.original ?? prev)
                          }}
                          name="mediaMobileId"
                          id="mediaMobileId"
                          errors={error?.message}
                          multiple={false}
                          initResource={videoMobileSrc}
                          reset={getValues('mediaMobileId') === 0}
                          allowFileTypes={[
                            'video/mp4',
                            'video/webm',
                            'video/m4v',
                            'video/mov',
                            'video/qt',
                          ]}
                          limitFileSize={
                            CONTENT_MANAGEMENT_VALIDATION.MAX_VIDEO_SIZE
                          }
                          minFileSize={
                            CONTENT_MANAGEMENT_VALIDATION.MIN_VIDEO_SIZE
                          }
                          changeLoading={setIsModalMobileLoading}
                          uploadType={EMediaType.VIDEO as any}
                          uploadCategory={EMediaCategory.CONTENT}
                        />
                      </>
                    )
                  }}
                />
                <SelectMedia
                  buttonClassName="w-fit ml-auto"
                  isNotGrid
                  onClickSelectMedia={() => {
                    setSelectedField((pre) => 'mobile')
                    setShowModalSelectMedia(true)
                    setSelectMediaType(EMediaType.VIDEO)
                  }}
                  isLoadingMedia={isModalMobileLoading}
                />
              </div>
            </InputWrapperVideoGridStyled>
          </div>
        </div>
      )}
      {showModalSelectMedia ? (
        <>
          <SelectMediaModal
            isOpen={showModalSelectMedia}
            onClose={onCloseModalSelectMedia}
            mediaType={selectMediaType}
            category={EMediaCategory.CONTENT}
            onSelectMedia={onSelectMediaVideoAndImage}
          />
        </>
      ) : (
        <></>
      )}
    </Card>
  )
}

const InputWrapperVideoGridStyled = styled.div`
  & > div {
    min-width: 400px;
  }

  .textarea {
    margin-top: 10px;
    min-height: 420px;
    height: 100%;
  }

  .Input__field-container {
    width: 100%;

    label {
      height: 500px;
    }
  }
`
